import { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext } from "../App";
import "../css/MonoOrderConfirm.css";
import Label from "./Label";
import api from "./api/api";
import currencyFormat from "./functions/functions";

function MonoOrderConfirm({ onClose }) {
	const { settings, monoOrderConfirmVisible, history, setHistory } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const [order, setOrder] = useState(false);

	useEffect(() => {
		if (monoOrderConfirmVisible.id) loadOrder();
	}, [monoOrderConfirmVisible]);

	async function loadOrder() {
		console.log("load_customer");
		const response = await api.post("/orders/get/" + monoOrderConfirmVisible.id + "/");
		if (response.success === 0) alert(response.error);
		setOrder(response.data);
		if (!history.find((o) => o.id == response.data.id)) {
			const newHistory = [response.data, ...history];
			if (newHistory.length > 10) newHistory = newHistory.slice(0, 10);
			setHistory(newHistory);
		}
	}

	return (
		<div
			className="mono-order-confirm"
			style={{
				backgroundColor: settings.selfordering.color1,
			}}
		>
			<div className="content">
				<h4>
					<Label number={140} />
				</h4>
				<span>
					<Label number={141} />
				</span>
				<h1>{order.number}</h1>
				<h4>ID: {monoOrderConfirmVisible.id}</h4>
				<img
					src={
						"https://api.yellgo.cloud/class/barcode.php?f=png&s=qr&p=0&w=500&h=500&d=" +
						monoOrderConfirmVisible.id
					}
				/>
				<div className="recap">
					<div className="recap-header">
						<div className="recap-header-title">
							<strong><Label number={148} /></strong>
						</div>
						<div className="recap-header-item">
							<Label number={33} />: <strong>{order.name}</strong>
						</div>
					</div>
					<div className="recap-products">
						{order.products &&
							order.products.map((product, index) => {
								return (
									<div className="recap-product" key={index}>
										<div className="recap-product-name">
											{product.name}
											<div className="variants">
												{product.variants &&
													product.variants.map((variant, index) => {
														return (
															<div className="variant" key={index}>
																{variant.qty}x {variant.name}
															</div>
														);
													})}
											</div>
										</div>
										<div className="recap-product-quantity">{product.qty}</div>
										<div className="recap-product-price">
											{currencyFormat(product.price, false, shop.currency)}
										</div>
									</div>
								);
							})}
					</div>
					<div className="total">
						<span>Totale:</span> {currencyFormat(order.total, false, order.currency)}
					</div>
				</div>


				<button
					onClick={onClose}
					className="button"
					style={{
						backgroundColor: settings.selfordering.color1,
						color: settings.selfordering.color2,
					}}
				>
					<Label number={142} />
				</button>
			</div>
		</div>
	);
}

export default MonoOrderConfirm;
